if(!Event) {
    var Event = {};
}

Event.ERROR = 'error';
Event.INTERNAL_ERROR = 'internal_error';
Event.ACCESS_DENIED = 'accessDenied';

Event.NOTIFICATION = 'notification';
Event.LOADING = 'loading';

Event.MODULE_CHANGED = 'moduleChanged';
